import { useCallback } from 'react';
import { useProfile } from '@/hooks/useProfile.hook';
import { Providers } from '@/types/providers.type';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const useVerifyConnectedAccount = () => {
  const navigate = useNavigate();
  const { reloadProfile } = useProfile();

  const [searchParams] = useSearchParams();

  const code = searchParams.get('oauth_token') || searchParams.get('code') || '';
  const verifier = searchParams.get('oauth_verifier') || '';
  const provider = localStorage.getItem('connect_provider') as Providers;

  // const [twitterConnectQuery] = useTwitterControllerConnectSuccessMutation();
  // const [discordConnectQuery] = usePostApiV1DiscordDiscordconnectMutation();
  // const [githubConnectQuery] = usePostApiV1GithubGithubconnectMutation();

  const verifyCallback = useCallback(() => {
    // if (provider === 'twitter' && code && verifier) {
    //   twitterConnectQuery({
    //     token: code,
    //     verifier: verifier,
    //   })
    //     .unwrap()
    //     .finally(() => {
    //       localStorage.removeItem('connect_provider');
    //       reloadProfile().then(() => {
    //         navigate('/tasks');
    //       });
    //     });
    // }
    // if (provider === 'discord' && code) {
    //   discordConnectQuery({ code })
    //     .unwrap()
    //     .finally(() => {
    //       localStorage.removeItem('connect_provider');
    //       reloadProfile().then(() => {
    //         navigate('/tasks');
    //       });
    //     });
    // }
    //
    // if (provider === 'github' && code) {
    //   githubConnectQuery({ code })
    //     .unwrap()
    //     .finally(() => {
    //       localStorage.removeItem('connect_provider');
    //       reloadProfile().then(() => {
    //         navigate('/tasks');
    //       });
    //     });
    // }
  }, [code, verifier]);

  return verifyCallback;
};
